<router-outlet></router-outlet>
<!--*ngIf="loggedIn() && userHasProfile"-->

<app-profile [show]="loggedIn() && !userHasProfile"></app-profile>
<!--<app-profile *ngIf="loggedIn() && !userHasProfile"></app-profile>-->

<!-- Pied de page avec le lien de suppression de compte -->
<footer class="footer" *ngIf="showFooter">
  <div class="footer-content">
    <div class="footer-links">
      <a routerLink="/about">À propos</a>
      <a routerLink="/faq">FAQ</a>
      <a routerLink="/delete-account">Demande de suppression de compte</a>
    </div>
    <div class="footer-copyright">
      © {{ currentYear }} Lenali Kura
    </div>
  </div>
</footer>


